import { apiHolder, apis, mailPerfTool, } from 'api';
import { MailActions } from '@web-common/state/createStore';
import { debounceMailListRequest, ERROR_REQUEST_CANCLE, getMailListByIdFromStore, folderIdIsContact, getMapConfigBySameAccountKey } from '../../../util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { getMailListReqParams, getAdvanceSearchReqParams, getSearchListReqParams, asyncMailList, isMerge, conactMailList, getFilterCondParams, mailListDiff, getNewMailsFromList, formateMailList, separateUpdateIdAndStore, getIsSearchingMailByState, needTimeRangeByMailOrderType, getIsUseRealList, } from '../../customize';
import { MAIL_FILL_RANG_NUM, MAIL_LIST_INIT_RANGE_COUNT, MAIL_LIST_MORE_RANGE_COUNT, FLOLDER } from '../../../common/constant';
import { getIn18Text } from 'api';
import { getModuleAccessSelector } from '@web-common/state/reducer/privilegeReducer';
import { defaultSelectedMailId } from './mailReducer';
let isInitedRequest = true;
const ReducerName = 'MailReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
const systemApi = apiHolder.api.getSystemApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const dataTrackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const debouceReuestGroupWarp = debounceMailListRequest();
const doListMailBoxEntities = debouceReuestGroupWarp(mailApi.doListMailBoxEntities.bind(mailApi), 'doListMailBoxEntities');
const doListThreadMailBoxEntities = debouceReuestGroupWarp(mailApi.doListThreadMailBoxEntities.bind(mailApi), 'doListThreadMailBoxEntities');
const doSearchMail = debouceReuestGroupWarp(mailApi.doSearchMail.bind(mailApi), 'doSearchMail');
const doAdvanceSearchMail = debouceReuestGroupWarp(mailApi.doAdvanceSearchMail.bind(mailApi), 'doAdvanceSearchMail');
const doListMailBoxEntitiesFromDB = debouceReuestGroupWarp(mailApi.doListMailEntitiesFromDb.bind(mailApi), 'doListMailEntitiesFromDb');
thunkHelper({
    name: 'refreshMailList',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { showLoading = true, noCache = false } = params || {};
        const state = thunkAPI.getState().mailReducer;
        const { mailSearchKey, mailSearchStateMap, mailSearchAccount, selectedSearchKeys, realListCurrentPage, realListCurrentPageSize, selectedKeys, mailDataList } = state;
        const isUseRealList = state.useRealList;
        const filterCond = getFilterCondParams(state);
        const searchType = mailSearchStateMap[mailSearchAccount];
        const startIndex = !isUseRealList ? 0 : (realListCurrentPage - 1) * realListCurrentPageSize;
        const isSearching = getIsSearchingMailByState(state);
        if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.authAccountType) != null && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.authAccountType) != '0' && !isSearching && (mailDataList === null || mailDataList === void 0 ? void 0 : mailDataList.length) == 0) {
            const folderId = parseInt((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) + '');
            if (!isNaN(folderId)) {
                mailApi
                    .triggerReceive({
                    folderId: folderId,
                    _account: (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '',
                })
                    .then(() => {
                    reduxMessage.success({
                        content: getIn18Text('ZHENGZAIWEININJIASTB'),
                    });
                });
            }
        }
        if (['local', 'server'].includes(searchType) && mailSearchKey) {
            dispatch(Thunks.loadSearchMailList({
                startIndex: startIndex,
                noCache,
                showLoading,
                filterCond,
            }));
        }
        else if (searchType === 'advanced') {
            const accountKeys = selectedSearchKeys[mailSearchAccount] || {};
            const hasFolderFilter = !!accountKeys.folder && +accountKeys.folder !== FLOLDER.SEARCH_ALL_RESULT;
            const hasFromFilter = Array.isArray(filterCond) && filterCond.some(cond => (cond === null || cond === void 0 ? void 0 : cond.field) === 'from');
            if (noCache && hasFolderFilter && hasFromFilter) {
                dispatch(MailActions.doUpdateSuppressAdvancedRefillOnce(true));
                setTimeout(() => {
                    dispatch(MailActions.doUpdateSuppressAdvancedRefillOnce(false));
                }, 3000);
            }
            dispatch(Thunks.loadAdvanceSearchMailList({ startIndex: startIndex, noCache, showLoading, filterCond }));
        }
        else {
            const oldMailDataList = [...state.mailDataList];
            dispatch(Thunks.loadMailList({ startIndex: startIndex, noCache, showLoading })).then(res => {
                var _a, _b;
                if ((_a = res.payload) === null || _a === void 0 ? void 0 : _a.result.data) {
                    const newMailDataList = (_b = res.payload) === null || _b === void 0 ? void 0 : _b.result.data.map(mail => { var _a; return mail.id || ((_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id); });
                    const hasNew = newMailDataList.some(id => !oldMailDataList.includes(id));
                    dispatch(MailActions.doUpdateRefreshHasNewMail(hasNew));
                }
            });
        }
    },
    pending: (state, action) => {
        const { toTop = true } = action.meta.arg || {};
        if (toTop) {
            state.scrollTop = 0;
        }
    },
    rejected: (state, action) => {
        console.log(action);
    },
});
thunkHelper({
    name: 'loadMailList',
    request: async (params, thunkAPI) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { rejectWithValue, dispatch } = thunkAPI;
        const { startIndex = 0, noCache = false } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailReducer;
        const { mailTreeStateMap } = state;
        const { accountId = state.selectedKeys.accountId } = params;
        const isCorpMail = rootState.loginReducer.loginInfo.isCorpMailMode;
        const isThread = isMerge(state.selectedKeys.id, state.selectedKeys.accountId, Object.keys(state.mailSearchStateMap).length > 0);
        const reqFn = isThread ? doListThreadMailBoxEntities : doListMailBoxEntities;
        const reqParams = getMailListReqParams(state, startIndex, isCorpMail, params.noContactRace);
        const isTagReq = Array.isArray(reqParams.tag) && reqParams.tag.length > 0;
        const isMyCustomerReq = !!((_b = (_a = reqParams.filter) === null || _a === void 0 ? void 0 : _a.flags) === null || _b === void 0 ? void 0 : _b.customerMail);
        const isReceiverReadFilter = state.mailListStateTab === 'RECEIVER_READ' || state.mailListStateTab === 'RECEIVER_UNREAD';
        const _noCache = !!(((state.selectedKeys.id === FLOLDER.UNREAD || isTagReq || isMyCustomerReq || needTimeRangeByMailOrderType(state.mailListStateTab)) &&
            systemApi.isNetworkAvailable()) ||
            isReceiverReadFilter) || noCache;
        mailPerfTool.mailList('start', {
            isThread,
            noCache: _noCache,
            startIndex: reqParams.index,
            folder: reqParams.id,
            read: (_d = (_c = reqParams.filter) === null || _c === void 0 ? void 0 : _c.flags) === null || _d === void 0 ? void 0 : _d.read,
            label0: ((_e = reqParams.filter) === null || _e === void 0 ? void 0 : _e.label0) || 0,
        });
        const hasCustomerAuth = getModuleAccessSelector(rootState.privilegeReducer, 'CONTACT', 'VIEW');
        if (!hasCustomerAuth && isMyCustomerReq) {
            return {
                result: {
                    building: 0,
                    count: 30,
                    data: [],
                    index: 0,
                    query: reqParams,
                    total: 0,
                },
                reqParams,
                _noCache,
            };
        }
        const isAttachemtFilter = state.mailListStateTab === 'ATTACHMENT';
        if (isAttachemtFilter) {
            const searchModel = {
                start: startIndex,
                limit: state.useRealList ? state.realListCurrentPageSize : 30,
                fid: (_f = state === null || state === void 0 ? void 0 : state.selectedKeys) === null || _f === void 0 ? void 0 : _f.id,
                fids: [(_g = state === null || state === void 0 ? void 0 : state.selectedKeys) === null || _g === void 0 ? void 0 : _g.id],
                conditions: [
                    {
                        flags: Object.assign({}, (isAttachemtFilter ? { attached: true } : {})),
                        sentDate: isAttachemtFilter ? [moment().subtract(6, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')] : [],
                    },
                ],
                ignoreGroup: true,
            };
            const result = await doAdvanceSearchMail(searchModel, noCache, (_h = state === null || state === void 0 ? void 0 : state.selectedKeys) === null || _h === void 0 ? void 0 : _h.accountId);
            if (result) {
                return {
                    result: {
                        data: result.entities,
                        query: searchModel,
                        total: result === null || result === void 0 ? void 0 : result.total,
                    },
                    _noCache,
                };
            }
        }
        const result = await reqFn(Object.assign(Object.assign({}, reqParams), { _account: accountId }), _noCache).then((res) => {
            var _a;
            let emailType = '';
            if (accountId && getMapConfigBySameAccountKey(mailTreeStateMap, accountId)) {
                emailType = ((_a = getMapConfigBySameAccountKey(mailTreeStateMap, accountId)) === null || _a === void 0 ? void 0 : _a.emailType) || '';
            }
            if (Array.isArray(res)) {
                res = res.map(item => {
                    return Object.assign(Object.assign({}, item), { emailType });
                });
            }
            else {
                res.data = res.data.map(item => {
                    return Object.assign(Object.assign({}, item), { emailType });
                });
            }
            if (!isThread) {
                const mailEntreis = res;
                if ((reqParams.order && reqParams.order !== 'date') || (reqParams.desc !== undefined && !reqParams.desc)) {
                    const data = mailApi.orderByMailList(mailEntreis.data, reqParams);
                    if (Array.isArray(data)) {
                        mailEntreis.data = data;
                    }
                    else {
                        return {
                            total: data.total,
                            data: data.data,
                            index: reqParams.index,
                            query: reqParams,
                        };
                    }
                }
            }
            return res;
        });
        if (result && result.data && Array.isArray(result.data) && !isThread) {
            dispatch(Thunks.getMailListReadStatus({
                mailIds: result.data.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }).filter(item => item),
                req: Object.assign(Object.assign({}, reqParams), { _account: accountId }),
            }));
        }
        try {
            if (result && result.data && Array.isArray(result.data) && !isThread) {
                const mailInfos = result.data
                    .map(item => {
                    var _a, _b, _c;
                    if ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.tr_org_ec_id) {
                        return {
                            eid: (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.tr_org_ec_id,
                            mid: (_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.id,
                        };
                    }
                })
                    .filter(item => item);
                if (mailInfos && mailInfos.length > 0) {
                    dispatch(Thunks.batchCheckTrOrgInfo({
                        mailInfos: mailInfos,
                    }));
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        if (result) {
            return { result, reqParams, _noCache };
        }
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const isUseRealList = state.useRealList;
        const { showLoading = true, startIndex = 0 } = params;
        if (isUseRealList) {
            state.listLoading = showLoading;
            if (startIndex === 0) {
                state.realListCurrentPage = 1;
            }
        }
        else {
            if (showLoading && startIndex === 0) {
                state.listLoading = true;
            }
        }
    },
    fulfilled: (state, action) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const params = action.meta.arg || {};
        const res = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.result;
        const { reqParams, noCache } = action.payload || {};
        const { startIndex = 0, showLoading = true } = params;
        if (startIndex === 0 && state.mailListStateTab === 'ALL') {
            state.lastFetchFirstIndexTime = new Date().getTime();
        }
        const mailDataList = getMailListByIdFromStore(state.mailDataList, state.mailEntities);
        if (startIndex === 0 && state.selectedKeys.id === FLOLDER.UNREAD) {
            if ((res === null || res === void 0 ? void 0 : res.total) === 0 && ((_e = (_d = (_c = (_b = state.mailTreeStateMap) === null || _b === void 0 ? void 0 : _b.main) === null || _c === void 0 ? void 0 : _c.MailFolderTreeMap[FLOLDER.UNREAD]) === null || _d === void 0 ? void 0 : _d.entry) === null || _e === void 0 ? void 0 : _e.mailBoxUnread) !== 0) {
                dataTrackApi.track('pa_mail_unread_folder_count_error', {
                    type: 'unread',
                    data: { req: reqParams, res },
                });
            }
        }
        const isSearching = getIsSearchingMailByState(state);
        const isTaskFolder = state.selectedKeys && state.selectedKeys.id === FLOLDER.TASK;
        state.mailListInitIsFailed = false;
        if (!(res === null || res === void 0 ? void 0 : res.query) || !(res === null || res === void 0 ? void 0 : res.data)) {
            showLoading &&
                reduxMessage.error({
                    content: getIn18Text('FUWUDUANWEIFAN'),
                });
            state.listLoading = false;
            state.mailListInitIsFailed = true;
            return;
        }
        const isUnreadFolder = ((_f = state.selectedKeys) === null || _f === void 0 ? void 0 : _f.id) === FLOLDER.UNREAD;
        if (isUnreadFolder) {
            res.data = res.data.filter(item => { var _a; return ((_a = item.entry) === null || _a === void 0 ? void 0 : _a.folder) !== FLOLDER.SPAM; });
        }
        if (!(isInitedRequest && (reqParams === null || reqParams === void 0 ? void 0 : reqParams.isRealList) && startIndex === 0 && state.mailTotal !== 0)) {
            state.mailTotal = res.total >= 0 ? res.total : 0;
        }
        if (isInitedRequest) {
            isInitedRequest = false;
        }
        let list = ((reqParams === null || reqParams === void 0 ? void 0 : reqParams.isRealList) && !isTaskFolder) || startIndex === 0 ? [] : mailDataList;
        list = list.length > 0 ? asyncMailList(list, res.data) : res.data;
        if (isMerge(state.selectedKeys.id, state.selectedKeys.accountId, isSearching) && (res === null || res === void 0 ? void 0 : res.building) === 1) {
            state.showThreadBuildingTip = true;
        }
        else {
            state.showThreadBuildingTip = false;
        }
        if ((folderIdIsContact((_g = state.selectedKeys) === null || _g === void 0 ? void 0 : _g.id) || ((_h = state.selectedKeys) === null || _h === void 0 ? void 0 : _h.id) == (FLOLDER === null || FLOLDER === void 0 ? void 0 : FLOLDER.STAR)) && (res === null || res === void 0 ? void 0 : res.building) === 1) {
            state.showStarContactBuildingTip = true;
        }
        else {
            state.showStarContactBuildingTip = false;
        }
        separateUpdateIdAndStore(state, 'mailDataList', formateMailList(list), {
            key: 'mailList',
            exclude: ['receiver'],
        });
        state.listLoading = false;
        mailPerfTool.mailList('end', {
            count: list.length,
            isThread: isMerge(state.selectedKeys.id, state.selectedKeys.accountId, isSearching),
            noCache,
            read: (_k = (_j = reqParams === null || reqParams === void 0 ? void 0 : reqParams.filter) === null || _j === void 0 ? void 0 : _j.flags) === null || _k === void 0 ? void 0 : _k.read,
            label0: ((_l = reqParams === null || reqParams === void 0 ? void 0 : reqParams.filter) === null || _l === void 0 ? void 0 : _l.label0) || 0,
        });
    },
    rejected: (state, action) => {
        var _a;
        const params = action.meta.arg || {};
        const { showLoading = true } = params;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        if (state.useRealList) {
            state.mailTotal = 0;
        }
        if (error !== ERROR_REQUEST_CANCLE) {
            state.listLoading = false;
            state.listIsRefresh = false;
            if ((error === null || error === void 0 ? void 0 : error.code) === 'FA_NEED_AUTH2') {
                state.mailFolderIsLock = true;
                state.mailDataList = [];
            }
            else {
                state.mailListInitIsFailed = true;
                showLoading &&
                    reduxMessage.error({
                        content: getIn18Text('JIAZAISHIBAI'),
                    });
            }
        }
        console.error('MailListError', 'loadMailList-rejected', error);
    },
});
thunkHelper({
    name: 'loadAdvanceSearchMailList',
    request: async (params, thunkAPI) => {
        const { rejectWithValue, dispatch } = thunkAPI;
        const { startIndex = 0, noCache = false, filterCond: paramFilterCond } = params;
        const rawState = thunkAPI.getState().mailReducer;
        const isRefreshReset = noCache && startIndex === 0;
        const state = isRefreshReset ? Object.assign(Object.assign({}, rawState), { selectedSearchKeys: {} }) : rawState;
        if (isRefreshReset) {
            dispatch(MailActions.doUpdateSelectedSearchKey({}));
        }
        const filterCond = isRefreshReset ? [] : paramFilterCond !== null && paramFilterCond !== void 0 ? paramFilterCond : getFilterCondParams(state);
        const searchModel = getAdvanceSearchReqParams(state, filterCond, startIndex);
        if (startIndex === 0) {
            mailPerfTool.searchMail('advanced', 'start', {
                noCache: true,
                searchRange: 'all',
            });
        }
        dispatch(MailActions.updateAdvancedSearchParam({
            searchModel,
            noCache,
            mailSearchAccount: state.mailSearchAccount,
        }));
        return doAdvanceSearchMail(searchModel, noCache, state.mailSearchAccount);
    },
    pending: (state) => {
        state.advancedSearchLoading = true;
        if (state.refreshLoading) {
            state.refreshLoading = false;
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, noCache } = params;
        const isUseRealList = state.useRealList;
        if (isUseRealList) {
            state.mailTotal = res.total;
        }
        const searchList = isUseRealList ? [] : getMailListByIdFromStore(state.searchList, state.mailEntities);
        state.mailListInitIsFailed = false;
        if (noCache) {
            state.scrollTop = 0;
        }
        state.searchingRequestId = res.searchId;
        let list = startIndex === 0 || isUseRealList ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver'],
        });
        const isPaging = startIndex > 0;
        const resHasFolders = Array.isArray(res === null || res === void 0 ? void 0 : res.folders) && res.folders.length > 0;
        if (isPaging && !resHasFolders && state.searchResultObj) {
            state.searchResultObj = Object.assign(Object.assign({}, res), { folders: state.searchResultObj.folders, stats: state.searchResultObj.stats });
        }
        else {
            state.searchResultObj = res;
        }
        state.listLoading = false;
        state.searchLoading = false;
        state.advancedSearchLoading = false;
        if (startIndex === 0) {
            mailPerfTool.searchMail('advanced', 'end', {
                noCache: true,
                count: list.length,
                searchRange: 'all',
            });
        }
    },
    rejected: (state, action) => {
        var _a;
        const params = action.meta.arg || {};
        const { showLoading = true } = params;
        if (state.useRealList) {
            state.mailTotal = 0;
        }
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload;
        if (error !== ERROR_REQUEST_CANCLE) {
            state.listLoading = false;
            if ((error === null || error === void 0 ? void 0 : error.code) === 'FA_NEED_AUTH2') {
                state.mailFolderIsLock = true;
                state.mailDataList = [];
            }
            else {
                state.mailListInitIsFailed = true;
                showLoading &&
                    reduxMessage.error({
                        content: getIn18Text('JIAZAISHIBAI'),
                    });
            }
        }
        state.advancedSearchLoading = false;
        console.error('MailListError', 'loadAdvanceSearchMailList-rejected', error);
    },
});
thunkHelper({
    name: 'loadSearchMailList',
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const { mailSearchKey, mailSearchStateMap, searchingRequestId, mailSearchAccount } = state;
        const filterCond = getFilterCondParams(state);
        const { startIndex = 0 } = params;
        const isLocalSearch = mailSearchStateMap[mailSearchAccount] === 'local';
        const query = getSearchListReqParams(state, startIndex);
        const searchingId = searchingRequestId && searchingRequestId > -1 ? searchingRequestId : undefined;
        if (!isLocalSearch) {
            params.noCache = !(await mailApi.doGetSearchCacheInfo(mailSearchKey, Object.assign(Object.assign({}, query), { filterCond }), searchingId, true, mailSearchAccount));
        }
        if (startIndex === 0) {
            mailPerfTool.searchMail(isLocalSearch ? 'local' : 'sever', 'start', {
                noCache: !!params.noCache,
                searchWord: mailSearchKey,
                fid: query.id,
                searchRange: query.searchType,
            });
        }
        if (state.mailSearchMoreAccounts) {
            const allAccounts = await accountApi.getMainAndSubAccounts({ expired: false });
            if (allAccounts && allAccounts.length > 0) {
                const subEmails = allAccounts.map(item => item.id);
                thunkAPI.dispatch(MailActions.updateSearchParam({
                    noCache: !!params.noCache,
                    mailSearchKey,
                    isLocalSearch,
                    searchingId,
                    params: Object.assign(Object.assign({}, query), { accountId: mailSearchAccount, _account: mailSearchAccount, filterCond, subEmails }),
                }));
                delete query.id;
                query.ids = [];
                return doSearchMail(mailSearchKey, Object.assign(Object.assign({}, query), { accountId: mailSearchAccount, _account: mailSearchAccount, subEmails }), false, searchingId);
            }
        }
        thunkAPI.dispatch(MailActions.updateSearchParam({
            noCache: !!params.noCache,
            mailSearchKey,
            isLocalSearch,
            searchingId,
            params: Object.assign(Object.assign({}, query), { accountId: mailSearchAccount, _account: mailSearchAccount, filterCond }),
        }));
        return doSearchMail(mailSearchKey, Object.assign(Object.assign({}, query), { accountId: mailSearchAccount, _account: mailSearchAccount, filterCond }), isLocalSearch, searchingId);
    },
    pending: (state) => {
        if (state.refreshLoading) {
            state.refreshLoading = false;
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, noCache, account } = params;
        const { mailSearchStateMap, useRealList } = state;
        const searchList = useRealList ? [] : getMailListByIdFromStore(state.searchList, state.mailEntities);
        const searchType = mailSearchStateMap[account];
        const isLocalSearch = searchType === 'local';
        state.mailListInitIsFailed = false;
        let list = startIndex === 0 && !useRealList ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver', 'entry.brief'],
        });
        if (useRealList) {
            state.mailTotal = res.total;
        }
        state.searchResultObj = res;
        state.searchingRequestId = res.searchId;
        state.listLoading = false;
        state.searchLoading = false;
        if (startIndex === 0) {
            const query = getSearchListReqParams(state, startIndex);
            mailPerfTool.searchMail(isLocalSearch ? 'local' : 'sever', 'end', {
                noCache: !!noCache,
                count: list.length,
                fid: query.id,
                searchRange: query.searchType,
            });
        }
    },
    rejected: (state, action) => {
        var _a;
        const params = action.meta.arg || {};
        const { showLoading = true, startIndex = 0, noCache } = params;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload;
        let { listLoading, mailFolderIsLock, mailDataList, mailListInitIsFailed, mailSearchStateMap, mailSearchAccount } = state;
        if (error !== ERROR_REQUEST_CANCLE) {
            listLoading = false;
            if ((error === null || error === void 0 ? void 0 : error.code) === 'FA_NEED_AUTH2') {
                mailFolderIsLock = true;
                mailDataList = [];
            }
            else {
                mailListInitIsFailed = true;
                showLoading &&
                    reduxMessage.error({
                        content: getIn18Text('JIAZAISHIBAI'),
                    });
            }
        }
        const isLocalSearch = mailSearchStateMap[mailSearchAccount] === 'local';
        if (startIndex === 0) {
            const query = getSearchListReqParams(state, startIndex);
            mailPerfTool.searchMail(isLocalSearch ? 'local' : 'sever', 'end', {
                noCache: !!noCache,
                count: 0,
                fid: query.id,
                searchRange: query.searchType,
            });
        }
        console.error('MailListError', 'loadSearchMailList-rejected', error);
    },
});
thunkHelper({
    name: 'searchCloudMailListExtra',
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const { mailSearchKey, mailSearchAccount } = state;
        const filterCond = getFilterCondParams(state);
        const { startIndex = 0 } = params;
        const query = getSearchListReqParams(state, startIndex);
        return mailApi.doSearchMail(mailSearchKey, Object.assign(Object.assign({}, query), { accountId: mailSearchAccount, _account: mailSearchAccount, filterCond }), false, Math.random());
    },
    pending: (state) => {
        state.extraSearchCloudMailListObjStatus = 'pending';
    },
    fulfilled: (state, action) => {
        const res = action.payload;
        state.extraSearchCloudMailListObj = res;
        state.extraSearchCloudMailListObjStatus = 'success';
    },
    rejected: (state, action) => {
        state.extraSearchCloudMailListObjStatus = 'fail';
    },
});
thunkHelper({
    name: 'loadMailListFromDB',
    request: async (params, thunkAPI) => {
        console.log('syncAndResendMailEntry====loadMailListFromDB', params);
        const { startIndex = 0, accountId } = params;
        const state = thunkAPI.getState().mailReducer;
        const { mailDataList } = state;
        const reqParams = getMailListReqParams(state, startIndex, undefined, params.noContactRace);
        if (!!reqParams.noSync) {
            console.log('loadMailListFromDB return false, because noSync is true');
            return false;
        }
        const isUseRealList = state.useRealList;
        if (isUseRealList) {
            return false;
        }
        reqParams.count = mailDataList && mailDataList.length ? mailDataList.length : isUseRealList ? state.realListCurrentPageSize : 100;
        if (!isUseRealList && reqParams.count < MAIL_LIST_INIT_RANGE_COUNT) {
            reqParams.count = MAIL_LIST_INIT_RANGE_COUNT;
        }
        if (reqParams.count > 500) {
            reqParams.count = 500;
        }
        let result = await doListMailBoxEntitiesFromDB(Object.assign({ _account: accountId }, reqParams), accountId);
        return result;
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { showLoading = true, startIndex = 0 } = params;
        if (showLoading && startIndex === 0) {
            state.listLoading = true;
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const mailDataList = getMailListByIdFromStore(state.mailDataList, state.mailEntities);
        state.mailListInitIsFailed = false;
        if (res) {
            if (!res.query || !res.data) {
                console.error('loadMailListFromDB error');
                return false;
            }
            if (res.data.length >= 500 || mailDataList.length > res.data.length) {
                try {
                    const list = conactMailList(mailDataList, res.data);
                    state.mailDataList = formateMailList(list).map(v => v.id);
                }
                catch (e) {
                    console.error('loadMailListFromDB-conactMailList', e);
                }
            }
            else {
                separateUpdateIdAndStore(state, 'mailDataList', formateMailList(res.data), {
                    key: 'mailList',
                    exclude: ['receiver'],
                });
            }
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload;
        const params = action.meta.arg || {};
        const { showLoading = true } = params;
        if (error !== ERROR_REQUEST_CANCLE) {
            state.listLoading = false;
            state.mailListInitIsFailed = true;
            showLoading &&
                reduxMessage.error({
                    content: getIn18Text('JIAZAISHIBAI'),
                });
        }
        console.error('MailListError', 'loadMailListFromDB-rejected', error);
    },
});
thunkHelper({
    name: 'pullLastMail',
    request: async (params, thunkAPI) => {
        var _a;
        const { rejectWithValue } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const reqParams = getMailListReqParams(state, 0);
        const useRealList = getIsUseRealList(state);
        const currentPageSize = state.realListCurrentPageSize;
        reqParams.count = useRealList ? currentPageSize : MAIL_LIST_INIT_RANGE_COUNT;
        try {
            reqParams._account = (_a = state.selectedKeys) === null || _a === void 0 ? void 0 : _a.accountId;
            const result = await mailApi.doListMailBoxEntities(reqParams, true);
            if (result) {
                if (Array.isArray(result.data)) {
                    const dataList = result.data.map(item => {
                        var _a, _b;
                        if (item && (item === null || item === void 0 ? void 0 : item.isThread) && ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id) && !((_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.id.includes('--'))) {
                            return Object.assign(Object.assign({}, item), { id: item.id + '--' + item.entry.folder, entry: Object.assign(Object.assign({}, item.entry), { id: item.entry.id + '--' + item.entry.folder }) });
                        }
                        return item;
                    });
                    return Object.assign(Object.assign({}, result), { data: dataList });
                }
                return result;
            }
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    fulfilled: (state, action) => {
        const res = action.payload;
        const { scrollTop, noticeNum, mailTotal } = state;
        const mailDataList = getMailListByIdFromStore(state.mailDataList, state.mailEntities);
        console.log('[listThunks] pullLastMail res', res);
        if (res) {
            const isUseRealList = getIsUseRealList(state);
            const currentPage = state.realListCurrentPage;
            const isFirstPage = currentPage === 1;
            const shouldUpdateMailList = isUseRealList && isFirstPage;
            if (!res.query)
                return;
            const _res = res.data;
            if ((isUseRealList && isFirstPage && state.activeIds && state.activeIds.length < 1) ||
                (!isUseRealList &&
                    (state.mailDataList.length <= MAIL_LIST_INIT_RANGE_COUNT || (state.scrollTop <= MAIL_LIST_MORE_RANGE_COUNT && state.activeIds && state.activeIds.length > 1)))) {
                separateUpdateIdAndStore(state, 'mailDataList', formateMailList(_res), {
                    key: 'mailList',
                    exclude: ['receiver'],
                });
                if (!isUseRealList) {
                    state.mailTotal = mailTotal;
                }
                else {
                    state.mailTotal = res.total;
                    state.lastFetchFirstIndexTime = new Date().getTime();
                }
            }
            else {
                const diffParams = !isUseRealList ? mailListDiff(_res, mailDataList) : getNewMailsFromList(_res, state.lastFetchFirstIndexTime);
                if (diffParams != null) {
                    const { sumNewMail, insertPosi } = diffParams;
                    const _mailDatalist = !isUseRealList ? [..._res.slice(0, insertPosi), ...mailDataList.slice(insertPosi)] : isFirstPage ? _res : [];
                    state.noticeNum = noticeNum + sumNewMail;
                    if (!isUseRealList) {
                        state.mailTotal = mailTotal + sumNewMail;
                    }
                    else {
                        state.noticeNum = sumNewMail;
                    }
                    if (!isUseRealList || shouldUpdateMailList) {
                        separateUpdateIdAndStore(state, 'mailDataList', formateMailList(_mailDatalist), {
                            key: 'mailList',
                            exclude: ['receiver'],
                        });
                    }
                }
            }
        }
    },
});
thunkHelper({
    name: 'loadMailListIfNotFullScreen',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { accountId, ids } = params;
        const state = thunkAPI.getState().mailReducer;
        const { mailDataList, searchList, mailTotal, searchResultObj, useRealList, realListCurrentPageSize, realListCurrentPage } = state;
        const isSearching = getIsSearchingMailByState(state);
        const list = isSearching ? searchList : mailDataList;
        const total = isSearching ? searchResultObj.total : mailTotal;
        if (!useRealList) {
            if (list && list.length - 1 < MAIL_FILL_RANG_NUM && total > MAIL_FILL_RANG_NUM) {
                dispatch(Thunks.refreshMailList({ showLoading: false }));
            }
        }
        else {
            if (realListCurrentPage > 1) {
                const mailIdsLens = Array.isArray(ids) ? ids.length : 0;
                if (mailIdsLens) {
                    const leftCount = total - mailIdsLens;
                    if (leftCount) {
                        if (realListCurrentPageSize * (realListCurrentPage - 1) >= leftCount) {
                            dispatch(MailActions.doUpdateRealListPage({ page: realListCurrentPage - 1 }));
                        }
                    }
                }
            }
            dispatch(Thunks.refreshMailList({ showLoading: false }));
        }
    },
});
thunkHelper({
    name: 'resetRealListStateAndLoadList',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const mailSearching = state.mailSearching;
        dispatch(MailActions.doUpdateRealListPage({ page: 1 }));
        dispatch(MailActions.doUpdateMailListScrollTop(0));
        if (!params || !params.noLoad) {
            if (!mailSearching) {
                dispatch(Thunks.loadMailList({ startIndex: 0, noCache: true }));
            }
            else {
                if (mailSearching !== 'advanced') {
                    dispatch(Thunks.loadSearchMailList({
                        startIndex: 0,
                        noCache: true,
                    }));
                }
                else {
                    dispatch(Thunks.loadAdvanceSearchMailList({
                        startIndex: 0,
                        noCache: true,
                        filterCond: getFilterCondParams(state),
                    }));
                }
            }
        }
    },
});
thunkHelper({
    name: 'getMailListRequestParams',
    request: (params, thunkAPI) => {
        const { startIndex = 0, noCache = false, id = '' } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailReducer;
        const useRealList = state.useRealList;
        const currentPageSize = state.realListCurrentPageSize;
        const currentPage = state.realListCurrentPage;
        const isSearching = !!state.mailSearching;
        const dataList = isSearching ? state.searchList : state.mailDataList;
        const midList = dataList || [];
        const _idx = midList.indexOf(id);
        const { accountId = state.selectedKeys.accountId } = params;
        const isCorpMail = rootState.loginReducer.loginInfo.isCorpMailMode;
        const isThread = isMerge(state.selectedKeys.id, state.selectedKeys.accountId, Object.keys(state.mailSearchStateMap).length > 0);
        const reqParams = getMailListReqParams(state, _idx, isCorpMail, params.noContactRace);
        return Object.assign(Object.assign({}, reqParams), { _account: accountId, isThread, midList, index: useRealList ? (currentPage - 1) * currentPageSize + _idx : _idx });
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.error('getMailListRequestParams', error);
    },
});
thunkHelper({
    name: 'getMailIdList',
    request: async (params, thunkAPI) => {
        const { isThread = false, reqParams } = params;
        const reqFn = (params === null || params === void 0 ? void 0 : params.isThread) ? doListThreadMailBoxEntities : doListMailBoxEntities;
        const result = await reqFn(Object.assign(Object.assign({}, reqParams), { _account: reqParams._account }), true).then((res) => {
            if (!isThread) {
                const mailEntreis = res;
                if ((reqParams.order && reqParams.order !== 'date') || (reqParams.desc !== undefined && !reqParams.desc)) {
                    const data = mailApi.orderByMailList(mailEntreis.data, reqParams);
                    if (Array.isArray(data)) {
                        mailEntreis.data = data;
                    }
                    else {
                        return {
                            total: data.total,
                            data: data.data,
                            index: reqParams.index,
                            query: reqParams,
                        };
                    }
                }
            }
            return res;
        });
        if (result) {
            return { result, reqParams, _noCache: true };
        }
    },
    fulfilled: (state, action) => {
        var _a;
        const res = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.result;
        return res;
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.error('getMailListRequestParams', error);
    },
});
thunkHelper({
    name: 'getMailListReadStatus',
    request: async (params, thunkAPI) => {
        const { mailIds = [], req } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailReducer;
        const accountId = state.selectedKeys.accountId;
        if (accountId && !req._account) {
            req._account = accountId;
        }
        const mailTid2readStateMap = await new Promise(async (r, j) => {
            let res = {};
            setTimeout(async () => {
                {
                    try {
                        const state = thunkAPI.getState().mailReducer;
                        const { mailEntities } = state;
                        const mailEntryList = getMailListByIdFromStore(mailIds, mailEntities);
                        res = await mailApi.checkReadStatusOfSentMail(mailEntryList, req);
                    }
                    catch (e) {
                        console.error('getMailListReadStatus', e);
                    }
                    r(res);
                }
            }, 500);
        });
        return {
            mailIds,
            mailTid2readStateMap,
        };
    },
    fulfilled: (state, action) => {
        const { mailTid2readStateMap, mailIds } = action.payload;
        if (mailIds && mailIds.length && mailTid2readStateMap) {
            const mailEntryList = getMailListByIdFromStore(mailIds, state.mailEntities);
            mailEntryList.forEach(i => {
                const obj = mailTid2readStateMap[i.entry.tid];
                i.entry.rcptCount = (obj === null || obj === void 0 ? void 0 : obj.rcptCount) || 0;
                i.entry.readCount = (obj === null || obj === void 0 ? void 0 : obj.readCount) || 0;
                i.entry.innerCount = (obj === null || obj === void 0 ? void 0 : obj.innerCount) || 0;
                i.entry.innerRead = (obj === null || obj === void 0 ? void 0 : obj.innerRead) || 0;
                i.entry.openCount = (obj === null || obj === void 0 ? void 0 : obj.openCount) || 0;
                return i;
            });
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.error('getMailListReadStatus', error);
    },
});
thunkHelper({
    name: 'batchCheckTrOrgInfo',
    request: async (params, thunkAPI) => {
        const { mailInfos = [] } = params;
        const infos = await new Promise((resolve, reject) => {
            setTimeout(async () => {
                try {
                    const eids = mailInfos.map(item => item.eid);
                    const result = await mailConfApi.batchCheckTrOrgInfo(eids);
                    if (result && result.orgCertCheckList && Array.isArray(result.orgCertCheckList)) {
                        const eid2InfoMap = {};
                        result.orgCertCheckList.forEach((item, index) => {
                            eid2InfoMap[item.eid] = item;
                        });
                        const res = mailInfos.map(item => {
                            return Object.assign(Object.assign({}, eid2InfoMap[item.eid]), { mid: item.mid });
                        });
                        resolve(res);
                    }
                    else {
                        reject(new Error('Invalid response structure or empty list'));
                    }
                }
                catch (error) {
                    console.error('Error fetching mail list read status', error);
                    reject(error);
                }
            }, 500);
        });
        return { infos };
    },
    fulfilled: (state, action) => {
        const { infos } = action.payload;
        if (infos && infos.length) {
            const mailIds = infos.map(item => item.mid);
            const mailEntryList = getMailListByIdFromStore(mailIds, state.mailEntities);
            mailEntryList.forEach((mailEntry, index) => {
                mailEntry.entry.tr_org_ec_info = infos[index];
            });
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error during mail list status update';
        console.error('Error in handling the mail list status', error);
    },
});
thunkHelper({
    name: 'getTrOrgInfo',
    request: async (params, thunkAPI) => {
        const { eid, mid, mail } = params;
        const [account_name, domain] = mail.split('@');
        try {
            const result = await mailConfApi.getTrOrgCertInfo({
                eid,
                domain,
                account_name,
            });
            return { result, mid };
        }
        catch (error) {
            console.error('Failed to fetch organization certification info', error);
            return thunkAPI.rejectWithValue('Failed to fetch data');
        }
    },
    fulfilled: (state, action) => {
        const { result, mid } = action.payload;
        if (result && result.orgCertInfo) {
            const mailEntry = state.mailEntities[mid];
            if (mailEntry) {
                mailEntry.entry.tr_org_ec_info = Object.assign(Object.assign(Object.assign({}, mailEntry.entry.tr_org_ec_info), result.orgCertInfo), { mid });
            }
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error during mail list status update';
        console.error('Error in getTrOrgInfo', error);
    },
});
thunkHelper({
    name: 'getMailContent',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { mid, _account } = params;
        try {
            if (mid) {
                const state = thunkAPI.getState();
                const mailEntities = state.mailReducer.mailEntities;
                if (!mailEntities[mid]) {
                    const result = await mailApi.doGetMailContent(mid, false, false, undefined, { _account });
                    if (result) {
                        dispatch(MailActions.updateMailEntities({ mailList: [result] }));
                    }
                }
            }
        }
        catch (error) {
            return thunkAPI.rejectWithValue('Failed to fetch data');
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error during mail list status update';
        console.error('Error in getTrOrgInfo', error);
    },
});
thunkHelper({
    name: 'doExtractMailMainAccountFromAI',
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { list, refresh } = params || {};
        if (!refresh) {
            const mids = Array.isArray(list) ? list.map(mail => mail.mid) : [];
            const account = Array.isArray(list) && !!list.length ? list[0].uid : undefined;
            state.AI_tab_mids = mids;
            state.AI_tab_mailTotal = mids.length || 0;
            state.AI_tab_account = account;
        }
        state.AI_tab_listLoading = true;
    },
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const result = (await doListMailBoxEntities({ mids: state.AI_tab_mids, count: state.AI_tab_mids.length, _account: state.AI_tab_account }, true));
        if (Array.isArray(result === null || result === void 0 ? void 0 : result.data) && (result === null || result === void 0 ? void 0 : result.data.length)) {
            return result === null || result === void 0 ? void 0 : result.data;
        }
        else {
            return [];
        }
    },
    fulfilled: (state, action) => {
        const res = action.payload;
        separateUpdateIdAndStore(state, 'AI_tab_mailDataList', formateMailList(res), {
            key: 'mailList',
            exclude: ['receiver'],
        });
        state.AI_tab_listLoading = false;
        state.AI_tab_scrollTop = 0;
        state.AI_tab_mailListMenuVisiable = false;
        state.AI_tab_refreshLoading = false;
        state.AI_tab_selectedMailId = Object.assign({}, defaultSelectedMailId);
        state.AI_tab_mailTotal = res.length;
        state.AI_tab_mailListInitIsFailed = false;
        state.AI_tab_groupCollapseKeys = [];
    },
    rejected: (state, action) => {
        state.AI_tab_listLoading = false;
        state.AI_tab_scrollTop = 0;
        state.AI_tab_mailListMenuVisiable = false;
        state.AI_tab_refreshLoading = false;
        state.AI_tab_selectedMailId = Object.assign({}, defaultSelectedMailId);
        state.AI_tab_mailTotal = 0;
        state.AI_tab_mailListInitIsFailed = false;
        state.AI_tab_groupCollapseKeys = [];
    },
});
export const MailListThunks = Thunks;
export const MailListExtraReducersList = ReducersList;
